import styles from 'assets/jss/Report/UserInfoStyle';
import makeStyles from '@mui/styles/makeStyles';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import {digitsEnToFa} from 'persian-tools2';
import {Divider, Grid} from '@mui/material';
import {styled} from '@mui/material/styles';

import userInfoObject from 'helpers/userInfoObject';

const useStyles = makeStyles(styles);

const AccordionDetails = styled(MuiAccordionDetails)(({theme}) => ({
    padding: '0 23px 0',
    margin: 0,
}));

const Details = ({patientInfo, serialNumber}) => {
    const classes = useStyles();
    return (
        <div>
            {userInfoObject(patientInfo, serialNumber).map(({title, value, id}) => (
                <AccordionDetails key={id}>
                    <Grid
                        container
                        xs={12}
                        sx={{
                            alignItems: 'center',
                            justifyContent: 'center',
                            m: '10px 0',
                        }}>
                        <Grid
                            item
                            textAlign={'right'}
                            xs={id === 6 || id === 7 ? 7 : id === 4 ? 3 : 5}
                            className={classes.AccordionTitle}>
                            {title}
                        </Grid>
                        <Grid
                            item
                            textAlign={'left'}
                            sx={{letterSpacing: id === 1 || id === 7 ? '0.5px' : ''}}
                            xs={id === 6 || id === 7 ? 5 : id === 4 ? 9 : 7}
                            className={classes.AccordionValue}>
                            {value ? value : '_'}
                        </Grid>
                    </Grid>
                    <Divider sx={{width: '100%'}}/>
                </AccordionDetails>
            ))}
        </div>
    );
};

export default Details;
